import { IGetSpendingsResponse } from 'multirpc-sdk';
import { sleep } from '@ankr.com/common';

import userSpendingsDataMock from './data/userSpendingsDataMock.json';

export const fetchUserSpendingsMock =
  async (): Promise<IGetSpendingsResponse> => {
    await sleep(1000);

    return userSpendingsDataMock;
  };
